<template>
  <header class="top-0 bg-white dark:bg-darkblue-900 px-4 lg:px-10 flex-none">
    <div class="flex responsive-spacing-y space-x-2 items-center">
      <div
        v-if="!content.url"
        class="group flex-none h-11 w-11 bg-secondary-50 dark:bg-darkblue flex items-center justify-center rounded-full"
      >
        <BaseIcon :name="content.icon" class="text-secondary dark:text-darkblue-200" aria-hidden />
      </div>
      <div
        v-else
        class="group flex-none">
        <router-link :to="{ name: content.url, params: content.params }">
          <base-span-icon name="arrowleft" size="lg" mode="primary-phantom" />
        </router-link>
      </div>
      <div class="relative w-full">
        <ul v-if="content.breadcrumb" class="breadcrumbs -top-4 text-sm left-0 flex items-top lg:space-x-2 truncate lg:flex-row flex-col">
          <li v-for="(item, idx) in content.breadcrumb" :key="idx" class="">
              <router-link class="whitespace-pre-wrap" :to="{ name: item.path, params: item.params }">{{ item.name }}</router-link>
          </li>
        </ul>
        <div class="flex">
          <h1 class="font-medium dark:text-white">{{ content.title }}</h1>
          <base-tooltip-icon v-if="content.tooltip" size="sm" :content="content.tooltip" class="ml-2"/>
        </div>
      </div>
      <div
        v-if="hasNav"
        ref="nav"
        v-outside:click="{ exclude: ['nav'], handler: closeNav }"
        class="flex-none relative ml-auto lg:hidden"
      >
      </div>
    </div>
  </header>
</template>

<script>
// import DropDownNav from '@/components/DropDownNav.vue'
export default {
  name: 'base-header',
  props: {
    content: {
      type: [Array, Object],
      required: true
    }
  },
  components: {
  //    DropDownNav
  },
  data: function () {
    return {
      nav: false
    }
  },
  computed: {
    hasNav: function () {
      return this.content.nav
    }
  },
  methods: {
    toggleNav: function () {
      this.nav = !this.nav
    },
    closeNav: function () {
      this.nav = false
    }
  }
}
</script>
<style lang="scss" scoped>
.breadcrumbs {
  li {
    @apply text-secondary dark:text-white font-bold;
    &:not(:last-child) {
      @apply text-secondary-600 dark:text-white font-normal;
      &:after {
        content:'→';
        margin-left:0.25rem;
      }
    }
  }
}
</style>
